import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useRouteError } from 'react-router-dom';

import { ApiError } from '@/api/backend';
import { RouterButton } from '@/primitives/Button';
import { Illustration } from '@/primitives/Icons';

const ENVIRONMENT = import.meta.env.VITE_CUTR_ENV;

export const NotFound = ({ redirectTo }: { redirectTo?: string }) => {
  const { t } = useTranslation();

  return (
    <GenericErrorPage redirectTo={redirectTo}>
      <h3>{t('reseller.errors.notFound.title')}</h3>
      <p>{t('reseller.errors.notFound.body')}</p>
    </GenericErrorPage>
  );
};

const GenericErrorPage = ({
  children,
  redirectTo,
}: React.InputHTMLAttributes<HTMLInputElement> & { redirectTo?: string }) => {
  const { t } = useTranslation();
  const error = useRouteError() as Error;
  console.error(error);

  if (error instanceof ApiError && error.response?.status === 401) {
    return <RedirectToLogin />;
  }
  return (
    <div
      className="content"
      style={{
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <p style={{ width: '15rem' }}>
        <Illustration />
      </p>
      <br />
      {children}
      {ENVIRONMENT !== 'production' && (
        <pre>
          {error.message}
          {error.stack}
        </pre>
      )}
      <br />
      <RouterButton to={redirectTo || '/'} style={{ width: '18em' }}>
        {t('review.goToHome')}
      </RouterButton>
    </div>
  );
};

const RedirectToLogin = () => {
  localStorage.removeItem('cutlist-auth');

  const search = new URLSearchParams();
  search.set('redirect', window.location.pathname + window.location.search);

  return (
    <Navigate
      to={{
        pathname: '/windows/login',
        search: search.toString(),
      }}
      replace
    />
  );
};

export const redirectToLoginPage = (path = '/windows/login') => {
  const search = new URLSearchParams();
  search.set('redirect', window.location.pathname + window.location.search);
  localStorage.removeItem('cutlist-auth');
  window.location.href = `${path}?${search.toString()}`;
};
